export default function (value) {
  if (!value)
    return true;

  value = String(value).replace(/[^\d]+/g, '');

  if (!(value && value.length === 11))
    return false;

  let sum = 0, result;

  let list = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999'
  ];

  if (list.indexOf(value) >= 0)
    return false;

  for (let i = 1; i <= 9; i++)
    sum = sum + parseInt(value.substring(i - 1, i)) * (11 - i);

  result = (sum * 10) % 11;

  if ((result === 10) || (result === 11))
    result = 0;

  if (result !== parseInt(value.substring(9, 10)))
    return false;

  sum = 0;
  for (let i = 1; i <= 10; i++)
    sum = sum + parseInt(value.substring(i - 1, i)) * (12 - i);

  result = (sum * 10) % 11;

  if ((result === 10) || (result === 11))
    result = 0;

  return result === parseInt(value.substring(10, 11));
};
